import { Box, Button } from "@mui/material";
import { useState } from "react";
import { TLLabelViewerModal } from "./TLLabelViewerModal";

type Props = {
    onFileLoaded: (rawXml: string) => void;
    parseTL: (file: File) => Promise<void>;
    svgElement: SVGSVGElement | null
  };

function TLFileInput({ onFileLoaded, svgElement, parseTL }: Props) {
  const [open, setOpen] = useState(false);

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    await parseTL(file);

    const rawXml = await file.text();
    onFileLoaded(rawXml);
  };

  return (
    <>
      <Box display="flex" alignItems="center" gap={2} sx={{ mb: 2 }}>
        <input
          type="file"
          accept=".tl"
          onChange={handleFileChange}
          style={{ fontSize: "0.875rem" }}
        />
        <Button
          variant="outlined"
          size="small"
          onClick={() => setOpen(true)}
          disabled={!svgElement}
        >
          View Label
        </Button>
      </Box>

      <TLLabelViewerModal
        open={open}
        onClose={() => setOpen(false)}
        svgElement={svgElement}
      />
    </>
  );
}

export default TLFileInput;
